const PRODUCTS = [
  {
    product_id: 1,
    name_product: "Auclean",
    slug: "auclean",
    image_product:
      "/images/products/auclean-5s-cnc-sleeve-type-plate-mounter.png",
  },
  {
    product_id: 2,
    name_product: "Huitong",
    slug: "huitong",
    image_product: "/images/products/huitong.png",
  },
  {
    product_id: 3,
    name_product: "Ochem",
    slug: "ochem",
    image_product:
      "https://fdlgroup.co.uk/wp-content/uploads/2018/05/steel-drums-2.png",
  },
  {
    product_id: 4,
    name_product: "Primeblade",
    slug: "primeblade",
    image_product: "/images/products/primeblade.jpg",
  },
  {
    product_id: 5,
    name_product: "Scitech",
    slug: "scitech",
    image_product: "/images/products/scitech-home-barrels.jpg",
  },
  {
    product_id: 6,
    name_product: "Idemitsu Plaloc",
    slug: "plaloc",
    image_product: "/images/products/idemitsu-plaloc-zipper-profiles.png",
  },
];

export default PRODUCTS;
